module.exports = "../../../../platform/assets/pageMainIcon/jichudanganlei8.svg";